import type {LootsheetLock, LootsheetLockId} from '@models/lootsheetLock';

export interface State {
	readonly byId: Record<LootsheetLockId, LootsheetLock>;
}

export const LOCK = 'lootsheet-lock/LOCK';
export const UNLOCK = 'lootsheet-lock/UNLOCK';

export interface Actions {
	LOCK: {
		readonly type: typeof LOCK;
		readonly payload: {};
	};
	UNLOCK: {
		readonly type: typeof UNLOCK;
		readonly payload: {};
	};
}
